import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-star-rating',
    templateUrl: './star-rating.component.html',
    styleUrls: ['./star-rating.component.css'],
    standalone: false
})
export class StarRatingComponent {
  @Input() rating: number = 0;
  stars: boolean[] = Array(5).fill(false);
}
